const Iost = {
  symbol: 'iost',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm8.5-21L16 6l-8.5 5v10l8.5 5 8.5-5zm-8.768 5.407l-1.031-.606-.623.368-1.476-.863.628-.37-3.33-1.959 6.271-3.688 5.917 3.438-1.586.938-4.327-2.53-3.131 1.842 1.754 1.032.897-.53 1.476.863-.902.533 1.03.606.736-.434 1.476.862-.74.437 3.673 2.162-6.27 3.687-6.525-3.79.027-1.843 6.495 3.787 3.13-1.841-2.098-1.235-.785.463-1.476-.862z" fill-rule="evenodd"/>`;
  },
  colorIcon() {
    return `<g fill="none" fill-rule="evenodd"><circle cx="16" cy="16" fill="#1c1c1c" r="16"/><path d="M24.5 11v10L16 26l-8.5-5V11L16 6zm-8.768 5.407l-.79.467 1.476.862.785-.463 2.099 1.235-3.131 1.84-6.495-3.786-.027 1.843 6.526 3.79 6.27-3.687-3.674-2.162.74-.437-1.476-.862-.735.434-1.03-.606.901-.533-1.476-.863-.897.53-1.754-1.032 3.13-1.841 4.328 2.529 1.586-.938-5.917-3.438-6.27 3.688 3.329 1.959-.628.37 1.476.863.623-.368z" fill="#fff" fill-rule="nonzero"/></g>`;
  }
};
export default Iost;
